.chat {
  height: 100vh;
  width: 100vw;

  :global(.str-chat) {
    --str-chat__avatar-background-color: transparent;
  }

  :global(.str-chat__message-simple-name) {
    /* Bolded store name in message metadata */
    font: var(--str-chat__caption-strong-text);
  }
}

.header {
  flex-wrap: nowrap;
  justify-content: center;
}
